import React from 'react';
import { Avatar, Chip, Stack, Typography } from '@mui/material';
import { Groups, Campaign, Person, Dashboard } from '@mui/icons-material';

// Status filters
export const STATUSES = ['Launched','Draft','Completed','Archived'];

// Group campaigns by month/year
export function groupByMonth(items) {
  return items.reduce((groups, item) => {
    const date = new Date(item.date_key);
    if (isNaN(date)) return groups;
    const key = date.toLocaleString('default',{ month:'long',year:'numeric' });
    groups[key] = groups[key]||[];
    groups[key].push(item);
    return groups;
  }, {});
}

// Generic avatar renderer
export const renderAvatar = (item,type) => {
  let src;
  if (type==='companies') src = item.phphref;
  if (type==='creators')  src = item.pfphref;
  if (type==='clients')   src = item.profilephoto;
  return (
    <Avatar
      src={src}
      sx={{ width:56, height:56, mb:2, bgcolor: src ? 'transparent' : 'primary.light' }}
    >
      {!src && <Person fontSize="large" />}
    </Avatar>
  );
};

// Generic icon renderer
export const renderIcon = type => {
  const icons = {
    companies: <Groups fontSize="large"/>,
    campaigns: <Campaign fontSize="large"/>,
    creators:  <Person  fontSize="large"/>,
    clients:   <Person  fontSize="large"/>
  };
  return icons[type] || <Dashboard fontSize="large"/>;
};

// Move StatBadge into utils
export const StatBadge = ({ label, value, color='primary' }) => (
  <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Chip
      label={`$${value.toFixed(2)}`}
      size="small"
      sx={{
        bgcolor: `${color}.light`,
        color: `${color}.contrastText`,
        fontWeight: 600
      }}
    />
  </Stack>
);

// Move StatRow into utils
export const StatRow = ({ label, value, format=false, color }) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="caption" fontWeight={600} color={color || 'text.primary'}>
      {format ? `$${value.toFixed(2)}` : value}
    </Typography>
  </Stack>
);
